import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { logEvent } from "firebase/analytics";
  import { analytics } from './firebase';

const REDIRECT_CONFIG = {
  r: { 
    url: "https://hollowpad.web.app", 
    event: "referral_reddit" 
  },
  li: { 
    url: "https://hollowpad.web.app", 
    event: "referral_linkedin" 
  },
  roforum: {                                               url: "https://hollowpad.web.app",
    event: "referral_roblox_forum"
  },
  ig: { 
    url: "https://hollowpad.web.app", 
    event: "referral_instagram" 
  }
};

const RedirectHandler = () => {
  const { platform } = useParams();
  const target = REDIRECT_CONFIG[platform];

  useEffect(() => {
    if (target) {
      // 1. Log the specific event to Firebase
      logEvent(analytics, target.event, {
        platform_key: platform,
        destination: target.url
      });

      // 2. Redirect without adding to browser history
      // We use a slight delay or promise to ensure analytics sends
      window.location.replace(target.url);
    }
  }, [platform, target]);

  return (
    <div style={styles.container}>
      <div style={styles.loader}>
        <h2>Redirecting you...</h2>
        <div className="spinner"></div> 
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontFamily: 'sans-serif',
    textAlign: 'center',
    backgroundColor: '#f9f9f9'
  },
  loader: {
    padding: '20px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  }
};

export default RedirectHandler;
